import { cn } from '@/lib/utils';

import Card from '@/components/atoms/Card';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { Text } from '@/components/atoms/Text';

export type UniversalCardProps = {
  title: string;
  description?: RichTextFieldStrapiProps;
  image?: ImageStrapiProps;
  icon?: ImageStrapiProps;
  button?: LinkButtonStrapiProps;
  className?: string;
  hasHoverEffect?: boolean;
  hasShadow?: boolean;
};

export function UniversalCard(props: UniversalCardProps) {
  const {
    title,
    description,
    image,
    icon,
    button,
    className,
    hasHoverEffect = true,
    hasShadow = true,
  } = props;
  return (
    <Card
      hasHoverEffect={hasHoverEffect}
      hasShadow={hasShadow}
      classNames={{
        root: cn(
          'flex h-full flex-col items-start gap-4 p-4 hover:bg-brand-25',
          'dark:hover:bg-brand-975',
          className
        ),
      }}
    >
      {icon && <ImageStrapi width={32} height={32} block={icon} />}
      {image && (
        <ImageStrapi
          block={image}
          inner={{
            classNames: {
              container: 'w-full min-w-0',
              image: 'h-auto w-full max-h-[164px]',
            },
          }}
        />
      )}
      <div className='flex flex-1 flex-col gap-3'>
        {title && (
          <Text variant='subtitle-l-d' classNames={{ wrapper: 'font-serif' }}>
            {title}
          </Text>
        )}
        {description && (
          <RichTextFieldStrapi
            block={description}
            classNames={{
              paragraph:
                'text-body-l text-gray-dark-600 dark:text-gray-dark-500',
            }}
          />
        )}
      </div>
      {button && (
        <LinkButtonStrapi inner={{ fullwidth: true }} block={button} />
      )}
    </Card>
  );
}
